module.exports = __webpack_public_path__ + "0d9f1d63aab444b9f0b56b466948571f.fbx";